import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InputField from "../../../components/common/new/InputField/InputField";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { NEW_FRIEND_FIELDS } from "../../../contants/formFields";
import Styles from "./styles";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getOptions } from "../../../utils";
import { getSubDivisionDisplayName } from "../../../utils/helper";

// const DEFAULT_COUNTRY_ID = 99;
// const STRICT_ADDRESS_REGEX =
//   /^[a-zA-Z0-9\s/#.-]+,\s*[a-zA-Z0-9\s]+,\s*[a-zA-Z\s]+,\s*[a-zA-Z\s]+ - \d{6}$/;

function CreateNewFriend({ handleChange, errors, values, setFieldValue }) {
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [profession, setProfession] = useState([]);

  const selectedFriend = useSelector(
    (state) => state.view_members.selectedFriendFromSearch
  );
  // const [radio, setRadio] = React.useState("india");

  const getDivisions = async () => {
    const { data } = await IntroductionFormApi.getDivisions();
    if (data?.length) {
      setDivisions(data);
      const filteredDivision = data.find((s) => {
        return s.divisionId === Number(selectedFriend?.divisionId);
      });
      if (filteredDivision) {
        setSubDivisions(filteredDivision.subDivisions);
      }
    }
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);

    if (selectedFriend?.state) {
      const selectedState = response?.data?.find(
        (state) => Number(selectedFriend.state) === state.stateId
      );
      console.log({ selectedState, selectedFriend, data: response?.data });
      setCities(selectedState.cities);
    }
  };

  const getCountries = async () => {
    const response = await IntroductionFormApi.getCountries();
    setCountries(response.data);
  };

  const getProfessions = async () => {
    const response = await IntroductionFormApi.getProfessions();
    setProfession(response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
    getCountries();
    getProfessions();
  }, []);

  return (
    <div style={Styles.gridContainer}>
      <div style={{ ...Styles.gridItem, ...Styles.name }}>
        <InputField
          required
          label="New Member Name"
          name={NEW_FRIEND_FIELDS.NAME}
          value={values[NEW_FRIEND_FIELDS.NAME]}
          error={errors[NEW_FRIEND_FIELDS.NAME]}
          onChange={handleChange}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          required
          label="Address"
          name={NEW_FRIEND_FIELDS.ADDRESS_LINE_1}
          value={values[NEW_FRIEND_FIELDS.ADDRESS_LINE_1]}
          onChange={handleChange}
          placeholder="Flat No, Building Name, Area, City - 400101"
          error={errors[NEW_FRIEND_FIELDS.ADDRESS_LINE_1]}
          // error={
          //   values[NEW_FRIEND_FIELDS.ADDRESS_LINE_1] &&
          //   !STRICT_ADDRESS_REGEX.test(values[NEW_FRIEND_FIELDS.ADDRESS_LINE_1])
          //     ? "Format: Flat No, Building Name, Area, City - 400101"
          //     : errors[NEW_FRIEND_FIELDS.ADDRESS_LINE_1]
          // }
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Pincode"
          name={NEW_FRIEND_FIELDS.PINCODE}
          value={values[NEW_FRIEND_FIELDS.PINCODE]}
          error={errors[NEW_FRIEND_FIELDS.PINCODE]}
          onChange={handleChange}
          inputProps={{
            maxLength: 6,
          }}
        />
      </div>
      {/* <div style={Styles.gridItem}>
        <InputField
          label="Address Line 2"
          name={NEW_FRIEND_FIELDS.ADDRESS_LINE_2}
          onChange={handleChange}
        />
      </div> */}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.stateName}
          label="State"
          name={NEW_FRIEND_FIELDS.STATE}
          options={getOptions(states, "stateId")}
          error={errors[NEW_FRIEND_FIELDS.STATE]}
          value={values[NEW_FRIEND_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_FRIEND_FIELDS.STATE, "");
              setCities([]);
            } else {
              setFieldValue(NEW_FRIEND_FIELDS.STATE, selectedValue.value);
              setCities(selectedValue.cities);
            }
            setFieldValue(NEW_FRIEND_FIELDS.CITY, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.cityName}
          label="City"
          name={NEW_FRIEND_FIELDS.CITY}
          options={getOptions(cities, "cityId")}
          error={errors[NEW_FRIEND_FIELDS.CITY]}
          value={values[NEW_FRIEND_FIELDS.CITY]}
          disabled={!values[NEW_FRIEND_FIELDS.STATE]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_FRIEND_FIELDS.CITY, "");
            } else {
              setFieldValue(NEW_FRIEND_FIELDS.CITY, selectedValue.value);
            }
          }}
        />
      </div>
      {/* <div style={Styles.gridItem} /> */}
      <div style={Styles.gridItem}>
        <InputField
          required
          label="Contact Number"
          name={NEW_FRIEND_FIELDS.CONTACT_NUMBER}
          value={values[NEW_FRIEND_FIELDS.CONTACT_NUMBER]}
          error={errors[NEW_FRIEND_FIELDS.CONTACT_NUMBER]}
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          // required
          label="Email Address"
          name={NEW_FRIEND_FIELDS.EMAIL_ADDRESS}
          value={values[NEW_FRIEND_FIELDS.EMAIL_ADDRESS]}
          error={errors[NEW_FRIEND_FIELDS.EMAIL_ADDRESS]}
          onChange={handleChange}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.name}
          label="Division"
          name={NEW_FRIEND_FIELDS.DIVISION}
          options={getOptions(divisions, "divisionId")}
          error={errors[NEW_FRIEND_FIELDS.DIVISION]}
          value={values[NEW_FRIEND_FIELDS.DIVISION]}
          // disabled={values[NEW_FRIEND_FIELDS.DIVISION]}
          inputProps={{ required: true }}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_FRIEND_FIELDS.DIVISION, "");
              setSubDivisions([]);
            } else {
              setFieldValue(NEW_FRIEND_FIELDS.DIVISION, selectedValue.value);
              setSubDivisions(selectedValue.subDivisions);
            }
            setFieldValue(NEW_FRIEND_FIELDS.SUB_DIVISION, "");
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => getSubDivisionDisplayName(option.name)}
          label="Sub Division"
          name={NEW_FRIEND_FIELDS.SUB_DIVISION}
          options={getOptions(subDivisions, "divisionId")}
          error={errors[NEW_FRIEND_FIELDS.SUB_DIVISION]}
          value={values[NEW_FRIEND_FIELDS.SUB_DIVISION]}
          inputProps={
            values[NEW_FRIEND_FIELDS.DIVISION] === 52 ||
            values[NEW_FRIEND_FIELDS.DIVISION] === 53
              ? { required: true }
              : { required: false }
          }
          // disabled={values[NEW_FRIEND_FIELDS.DIVISION]}
          onChange={(selectedValue) => {
            if (!selectedValue) {
              setFieldValue(NEW_FRIEND_FIELDS.SUB_DIVISION, "");
            } else {
              setFieldValue(
                NEW_FRIEND_FIELDS.SUB_DIVISION,
                selectedValue.value
              );
            }
          }}
        />
      </div>
      {values[NEW_FRIEND_FIELDS.DIVISION] === 52 ||
      values[NEW_FRIEND_FIELDS.DIVISION] === 53 ? (
        <>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Contact Number"
              name={NEW_FRIEND_FIELDS.PARENT_CONTACT_NUMBER}
              value={values[NEW_FRIEND_FIELDS.PARENT_CONTACT_NUMBER]}
              onChange={handleChange}
              error={errors[NEW_FRIEND_FIELDS.PARENT_CONTACT_NUMBER]}
              inputProps={{
                maxLength: 10,
              }}
            />
          </div>
          <div style={Styles.gridItem}>
            <InputField
              required
              label="Parent's Email Address"
              name={NEW_FRIEND_FIELDS.PARENT_EMAIL_ADDRESS}
              value={values[NEW_FRIEND_FIELDS.PARENT_EMAIL_ADDRESS]}
              error={errors[NEW_FRIEND_FIELDS.PARENT_EMAIL_ADDRESS]}
              onChange={handleChange}
            />
          </div>
        </>
      ) : null}
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          label="Profession"
          variant="standard"
          value={values[NEW_FRIEND_FIELDS.PROFESSION]}
          name={NEW_FRIEND_FIELDS.PROFESSION}
          error={errors[NEW_FRIEND_FIELDS.PROFESSION]}
          getOptionLabel={(option) => option.profession}
          options={getOptions(profession, "professionsId")}
          // inputProps={{ required: true }}
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_FRIEND_FIELDS.PROFESSION,
              selectedValue?.value ?? ""
            );
          }}
        />
      </div>
      <div style={Styles.gridItem}>
        <AutoCompleteDropdown
          getOptionLabel={(option) => option.countryName}
          name={NEW_FRIEND_FIELDS.NATIONALITY_ID}
          options={getOptions(countries, "countryId")}
          inputProps={{ required: true }}
          error={errors[NEW_FRIEND_FIELDS.NATIONALITY_ID]}
          value={values[NEW_FRIEND_FIELDS.NATIONALITY_ID]}
          label="Nationality/Country"
          onChange={(selectedValue) => {
            setFieldValue(
              NEW_FRIEND_FIELDS.NATIONALITY_ID,
              selectedValue?.value ?? ""
            );
          }}
        />
      </div>
      {/* <div /> */}
      <div style={Styles.gridItem}>
        <InputField
          required
          label="Introducer's Name"
          name={NEW_FRIEND_FIELDS.INTRODUCED_BY_NAME}
          onChange={handleChange}
          value={values[NEW_FRIEND_FIELDS.INTRODUCED_BY_NAME]}
        />
      </div>
      <div style={Styles.gridItem}>
        <InputField
          label="Introducer's Contact Number"
          required
          name={NEW_FRIEND_FIELDS.INTRODUCED_BY_MOBILE_NUMBER}
          value={values[NEW_FRIEND_FIELDS.INTRODUCED_BY_MOBILE_NUMBER]}
          onChange={handleChange}
          inputProps={{
            maxLength: 10,
          }}
        />
      </div>

      <div style={Styles.gridItem}>
        <InputField
          label="Introducer's Email Address"
          name={NEW_FRIEND_FIELDS.INTRODUCED_BY_EMAIL}
          value={values[NEW_FRIEND_FIELDS.INTRODUCED_BY_EMAIL] || ""}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
const propTypes = {
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  values: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

CreateNewFriend.propTypes = propTypes;

export default CreateNewFriend;
